export default __webpack_public_path__ + "static/media/datamine-network.d7f52937.jpg";